module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_DA-a9fefe84cad821736bba00c02b338cb9.svg";